import { MapUtils } from '../../../utility/map-utils.js';
import { isSameData, isSameList } from '../../dto/data-model-utils.js';
import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../../dto/data-model.js';
import { BusinessModuleRef } from '../business-module-ref.js';
import { AnalyticsCartItemDto } from './analytics-cart-item.js';

export class AnalyticsCartDto extends DataModel {
  static readonly TYPE_ID: string = '48bcf44fec81475ebb03aed78c9d0b24';

  private constructor(
    public readonly eventId: string,
    public readonly deduplicationId: string,
    public readonly businessRef: BusinessModuleRef,
    public readonly contents: AnalyticsCartItemDto[],
  ) {
    super();
  }

  get $typeId(): string {
    return AnalyticsCartDto.TYPE_ID;
  }

  static create(args: {
      eventId: string,
      deduplicationId: string,
      businessRef: BusinessModuleRef,
      contents: AnalyticsCartItemDto[]
    }): AnalyticsCartDto {
    return new AnalyticsCartDto(
        args.eventId,
        args.deduplicationId,
        args.businessRef,
        args.contents
    );
  }

  public static fromMap(context: SerializationContext, map: SerializedData) {
    return new AnalyticsCartDto(
        MapUtils.getString(map, 'eventId'),
        MapUtils.getString(map, 'deduplicationId'),
        BusinessModuleRef.mustDecode(MapUtils.getString(map, 'businessRef')),
        MapUtils.getList<AnalyticsCartItemDto>(map, 'contents', (e) => {
          return context.fromData(e as SerializedData);
        }),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'eventId': this.eventId,
      'deduplicationId': this.deduplicationId,
      'businessRef': this.businessRef.encode(),
      'contents': this.contents.map((e) => context.toData(e)),
    };
  }

  clone(): this {
    return new AnalyticsCartDto(
        this.eventId,
        this.deduplicationId,
        this.businessRef.clone(),
        this.contents.map((e) => e.clone())
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return this.eventId === other.eventId &&
      this.deduplicationId === other.deduplicationId &&
      isSameData(this.businessRef, other.businessRef) &&
      isSameList(this.contents, other.contents, isSameData);
  }
}

export class AnalyticsCartDtoBuilder extends DataModelBuilder<AnalyticsCartDto> {
  build(context: SerializationContext, map: SerializedData): AnalyticsCartDto {
    return AnalyticsCartDto.fromMap(context, map);
  }
}
